import { useEffect } from "react"
import { useSetRecoilState } from "recoil"
import { userStateForAnalytics } from "@fuse/recoil/signup"
import { auth, analytics } from "@firebaseConfig/clientApp"
import { setUserId } from "firebase/analytics"
import { onAuthStateChanged, User } from "firebase/auth"
import { v4 as uuidv4 } from "uuid"

// Function to generate or retrieve an anonymous user ID
const getAnonymousUserId = (): string => {
  let anonymousId = localStorage.getItem("anonymousUserId")
  if (!anonymousId) {
    anonymousId = uuidv4()
    localStorage.setItem("anonymousUserId", anonymousId)
  }
  return anonymousId
}

const useTrackUser = (): void => {
  const setUser = useSetRecoilState(userStateForAnalytics)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user: User | null) => {
      if (user) {
        // Logged-in user
        setUserId(analytics, user?.uid)
        setUser({ userId: user?.uid, isAnonymous: false })
        console.log("Tracking logged-in user:", user?.uid)
      } else {
        // Anonymous user
        const anonymousId = getAnonymousUserId()
        setUserId(analytics, anonymousId)
        setUser({ userId: anonymousId, isAnonymous: true })
        console.log("Tracking anonymous user:", anonymousId)
      }
    })

    return () => unsubscribe() // Cleanup listener
  }, [setUser])
}

export default useTrackUser
